<template>
  <div class="vl-header">
    <!--头部内容区-->
    <div class="hd-content">
      <!--头部左侧-->
      <div class="hd-l">
        <div class="dl-logo">
          <img @click="toHomePageClick" src="../assets/img/logo.png" alt="" />
          <!--<span>拓维智慧教育云平台</span>-->
        </div>
        <ul class="hd-menu">
          <li>
            <router-link
              :class="{'is-active': $route.name === 'home'}"
              :to="{ name: 'home'}"
            >
              <span>首页</span>
              <span class="bottom-line"></span>
            </router-link>
          </li>
          <!-- <li @click="goToAppCenter">
            <a>
              <span>应用中心</span>
              <span class="bottom-line border_radius_4"></span>
            </a>
          </li> -->
          <li 
            v-for="(item, index) in menuList" 
            :key="'vl-header-r' + index" >
            <router-link
              v-if="item.name !== 'personDefault' || isLogin"
              :class="{'is-active': $route.name === item.name}"
              :to="{ name: item.name, query: { docId: item.docId } }"
            >
              <span>{{ item.title }}</span>
              <span class="bottom-line"></span>
            </router-link>
          </li>
        </ul>
      </div>

      <!--头部右侧用户信息-->
      <div class="hd-r" v-if="!isLogin">
        <!-- <div class="dr-item ">注册</div> -->
        <div class="dr-item active" @click="userLogin">登录</div>
      </div>
      <div class="hd-r" v-else>
        <div class="hd-r-user">
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="hd_selec"
            v-model="isShowPopover"
          >
            <ul class="hd_user_pl user_info">
              <li
                :class="curRoutePath.includes('Setting') ? 'self' : ''"
                @click="() => {handleCommand('userSetting')}">个人设置</li>
              <li class="hd_logout" @click="() => {handleCommand('logout')}"> 
                <img style="transform: translateY(3px);" src="../assets/img/log_out.png" alt=""> 
                退出登录
              </li>
            </ul>
            <span class="hd_info" slot="reference">
              <div class="touxiang"></div>
              <p class="person_info loginName">
                {{loginName}}<i class="el-icon-caret-bottom"></i>
              </p>
            </span>
          </el-popover>
        </div>
        <!-- <el-dropdown trigger="click" @command="handleCommand" class="user-dropdown"> 
          <div class="el-dropdown-link">
            <div class="touxiang"></div>
            <div class="loginName">
              {{ loginName }}
            </div>
            <i
              class="el-icon-caret-bottom"
              style="color: #999; margin-left: 10px"
            ></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userSetting">
              <i class="iconfont icon-Floatingwindow_Personalsettings"></i>
              个人设置
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <i class="iconfont icon-Floatingwindow_Logout"></i>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>

    <!--登录弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      title="开放平台账号登录"
      center
      :visible.sync="dialogFormVisible"
      width="800px"
      custom-class="loginWindow"
      class="take"
      append-to-body
    >
      <div class="loginBg">
        <img src="../assets/img/header/loginBg.png" alt="" />
      </div>
      <el-form
        :model="formInline"
        ref="Loginform"
        :rules="rules"
        style="width: 340px; margin: 0 auto"
      >
        <el-form-item prop="user">
          <el-input
            placeholder="请输入邮箱"
            maxlength="60"
            v-model="formInline.user"
          >
            <img slot="prefix" src="../assets/img/header/user.png" alt="" />
            <!-- <i  class="el-input__icon el-icon-search"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input
            placeholder="请输入密码"
            maxlength="20"
            v-model="formInline.pwd"
            show-password
            class="pwdInput"
          >
            <img slot="prefix" src="../assets/img/header/pwd.png" alt="" />
            <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            placeholder="请输入验证码"
            v-model="formInline.code"
            maxlength="4"
            style="width: 63%"
          >
            <img slot="prefix" src="../assets/img/header/code.png" alt="" />
            <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
          </el-input>
          <img
            :src="'data:image/jpg;base64,' + base64Img"
            alt=""
            width="113px"
            height="50px"
            style="float: right"
            @click="getBase64Code"
          />
        </el-form-item>
        <p class="operation">
          <span @click="activeAccount">账号激活</span>
          <span @click="resetPassword">忘记密码？</span>
        </p>
        <el-form-item>
          <el-button
            type="primary"
            :disabled="loginLoading"
            @click="immediately('Loginform')"
            >立即登录</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--退出登录-->
    <el-dialog 
      style="z-index: 4;"
      title="退出登录" 
      :visible.sync="logoutDialogVisible" 
      width="30%"
      :modal-append-to-body="false">
      <span>确定退出登录吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logoutDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="logoutLoading"
          @click="confirmLogout"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  CommonGetCaptcha,
  CommonPostCompanyLogin,
  CommonPostCompanyLogout,
  CommonGetIndexDocInfo,
} from "@/views/index/api/api.common.js";
export default {
  data() {
    return {
      isShowPopover: false,
      menuList: [
//        { title: "首页", name: "home" },
//        { title: "应用中心", name: "appCenter" },
        { title: "基础文档", name: "basicDoc", docId: null },
        { title: "服务能力", name: "servicePower", docId: null },
        { title: "个人中心", name: "personDefault" },
      ],
      loginLoading: false,
      dialogFormVisible: false,
      logoutDialogVisible: false,
      logoutLoading: false,
      formInline: {
        user: null,
        pwd: null,
        code: null,
        uuid: null,
      },
      base64Img: "",
      userMeg: {},
      rules: {
        pwd: [
          // 
          { required: true, message: "请输入密码", trigger: "blur" },
//          {
//            pattern:
//              /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z`~!/\\@#$%^&*()+=|{}':;',\[\].<>?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]{8,20}$/,
//            // pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/,
//            message: "请输入8-20位字母加数字组合密码",
//            trigger: "blur",
//          },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          // {
          //     pattern: /^\d{6}$/,
          //     message: "请输入正确的验证码",
          //     trigger: "blur",
          // },
        ],
        user: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
//          {
//            pattern:
//              /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
//            message: "请输入正确的邮箱地址",
//            trigger: "blur",
//          },
        ],
      },
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.loginToken;
    },
    loginName() {
      return this.$store.state.loginUser.companySimpleName;
    },
    routeBeforeName() {
      return this.$store.state.routeBeforeName;
    },
    curRoutePath() {
      return this.$route.path;
    },
  },
  watch: {
    routeBeforeName(data) {
      if (data) {
        this.dialogFormVisible = true;
      }
    },
    dialogFormVisible(ev) {
      if (!ev) {
        this.resetRouteBeforeName();
        this.$refs.Loginform.resetFields();
      } else {
        this.getBase64Code();
      }
    },
  },
  created() {
    this.getIndexDocInfo();
  },
  mounted() {
    // 判断用户有没有登录

    $("body").bind("keydown", (event) => {
      if (event.keyCode === 13) {
        this.immediately("Loginform");
      }
    });
  },
  methods: {
    toHomePageClick() {
      this.$router.push({ name: 'home' })
    },
    /**
     * 跳到应用中心
     * */
    goToAppCenter() {
      let url = window.ENV_API.WORK_URL + 'portalUi/#/app-center/'
      window.open(url)
    },
    // 获取不同的docId
    getIndexDocInfo() {
      CommonGetIndexDocInfo().then(
        (success) => {
          if (success.code == "00000") {
            this.menuList.map((el) => {
              if (el.name == "basicDoc") {
                el.docId = success.result.baseDocId;
              }
              if (el.name == "servicePower") {
                el.docId = success.result.svcDocId;
              }
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    /**
     * 重置store的routeBeforeName
     * */
    resetRouteBeforeName() {
      this.$store.commit("setRouteBeforeName", {
        routeBeforeName: null,
      });
    },

    /**
     * 点击登录
     * */
    userLogin() {
      this.dialogFormVisible = true;
      this.resetRouteBeforeName();
    },

    /**
     * 获取图片验证码
     * */
    getBase64Code() {
      CommonGetCaptcha().then((res) => {
        if (res && res.result) {
          this.base64Img = res.result.img;
          this.formInline.uuid = res.result.uuid;
        }
      });
    },

    /**
     * 账号激活
     * */
    activeAccount() {
      this.dialogFormVisible = false;
      this.$router.push({ name: "activeAccount" });
      this.resetRouteBeforeName();
    },

    /**
     * 忘记密码
     * */
    resetPassword() {
      this.dialogFormVisible = false;
      this.$router.push({ name: "findPwd" });
      this.resetRouteBeforeName();
    },

    /**
     * 确定登录
     * */
    immediately(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          let { user, code, pwd, uuid } = this.formInline;
          let param = {
            captchaCode: code,
            loginName: user,
            loginPwd: this.rsaEncrypt(pwd),
            uuid: uuid,
          };
          CommonPostCompanyLogin(param).then((res) => {
            if (res && res.result) {
              sessionStorage.setItem(
                "developer_user_info",
                JSON.stringify(res.result)
              );
              this.$store.commit("setLoginUser", {
                loginUser: res.result,
              });
              this.$store.commit("setLoginToken", {
                loginToken: true,
              });
              this.dialogFormVisible = false;
              if (this.routeBeforeName) {
                this.$router.push({ name: this.routeBeforeName });
              }
            } else {
              this.getBase64Code();
            }
            this.loginLoading = false;
          });
        }
      });
    },
    rsaEncrypt(data) {
      // 公钥
      let PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAg8DC7bojdiFoqNjZHD+beD2sZnjwXJ17OyvpmRdxlTK2ABzWKm1ugid4Bo66z1IIu78t8JO7Fms92QR+J/w6ykIUzRGqsmp3j1e47boK0zuYgp5z/afQrL4F+G5NW3Wb2626mmM3G4WPho9M88E+v5j2y9wZTM7az1KomKKEvBwY2cROJFaYp04OSFJo9aee5ynGX66rgr1zStEPaz0jW0v4g7mrkEnu6p1EgW3Z8n7sieUqTYk+yn6lNf3lnb4e6QUAb1gpG0+9DiTDvAzePazjX3U7BTFOlMkBm6PFx+x+LTNUIrRn+2EBOYP2TKiZoDSOQS1jsuPcyOSYEhzzcQIDAQAB';
      // 使用公钥加密
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(PUBLIC_KEY)
      let result = encrypt.encrypt(data)
      return result
    },
    decrypt(msg) {
      const privateKey = ''
      let decrypt = new JSEncrypt()
      decrypt.setPrivateKey(privateKey)
      var decryptMsg = decrypt.decrypt(msg)
      return decryptMsg
    },

    // 头像部分下拉
    handleCommand(command) {
      if (command == "userSetting") {
        this.$router.push({ name: "userSetting" });
      } else {
        this.isShowPopover = false
        this.logoutDialogVisible = true;
      }
    },

    /**
     * 登出
     * */
    confirmLogout() {
      this.logoutLoading = true;
      this.resetRouteBeforeName();
      CommonPostCompanyLogout().then(() => {
        // 如果当前页面需要登录，则跳到首页
        if (!this.$route.meta.unrequireLogin) {
          this.$router.push({ name: "home" });
        }
        sessionStorage.removeItem("developer_user_info");
        this.$store.commit("setLoginUser", {
          loginUser: null,
        });
        this.$store.commit("setLoginToken", {
          loginToken: false,
        });
        this.logoutDialogVisible = false;
        this.logoutLoading = false;
      });
    },
  },
  beforeDestroy() {
    $("body").unbind("keydown");
  },
};
</script>
<style lang="scss" scoped>
.vl-header {
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
  @include setColor("background-color", "chunk_2");
  .hd-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .hd-l {
      display: flex;
      justify-content: center;
      align-items: center;
      .dl-logo {
        margin-right: 98px;
        cursor: pointer;
        img {
          vertical-align: middle;
          height: 50px;
        }
        span {
          @include setColor("color", "font_1");
          font-weight: 600;
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          height: 50px;
          line-height: 50px;
        }
      }
      > ul {
        display: flex;
        > li {
          margin-right: 50px;
          /*width: 90px;*/
          display: flex;
          justify-content: center;
          > a {
            position: relative;
            display: inline-block;
            height: 71px;
            line-height: 71px;
            font-size: 18px;
            text-decoration: none !important;
            text-align: center;
            transition: all 0.2s ease-out;
            overflow: hidden;
            cursor: pointer;
            @include setColor("color", "font_1");
            > span {
              display: block;
              z-index: 2;
            }
            .bottom-line {
              width: 100%;
              height: 4px;
              @include setColor("background-color", "chunk_1");
              position: absolute;
              bottom: 0;
              -webkit-transform: scale(0);
              -moz-transform: scale(0);
              -ms-transform: scale(0);
              -o-transform: scale(0);
              transform: scale(0);
              transition: all 0.2s ease-out;
            }
            &:hover {
            }
            &.is-active {
              cursor: default;
              font-weight: 600;
              @include setColor("color", "font_2");
              .bottom-line {
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -ms-transform: scale(1);
                -o-transform: scale(1);
                transform: scale(1);
              }
            }
          }
        }
      }
    }
    .hd-r {
      display: flex;
      flex-direction: row-reverse;
      width: 200px;
      .hd-r-user {
        display: flex;
        justify-content: center;
        align-items: center;
        .hd_info {
          display: flex;
          align-items: center;
        }
        .person_info {
          color: #333;
          cursor: pointer;
          i {
            font-size: 16px;
            margin-left: 5px;
            color: #999;
          }
        }
      }
      .dr-item {
        width: 80px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        @include setColor("color", "font_1");
        border-left: 1px solid #f2f2f2;
        &.active {
          @include setColor("background-color", "chunk_1");
          @include setColor("color", "font_3");
        }
      }
    }
  }
}

.hd_user_pl {
  li {
    text-align: center;
    width: 100%;
    height: 48px;
    line-height: 48px;
    &:hover {
      cursor: pointer;
      color: #498BFF;
    }
  }
  .self {
    background-color: #E8F3FE;
    color: #498BFF;
  }
  .hd_logout {
    border-top: 1px solid #B7B6DA;
  }
}
</style>
<style lang="scss">
/*登录相关*/
.afterLogin .el-dropdown-link {
  height: 64px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-align-items: center;
  -webkit-align-items: center;
  align-items: center;
}
.el-dropdown-menu {
  top: 50px !important;
  min-width: 150px;
}
.el-dropdown-menu__item {
  padding: 0 50px 0 10px !important;
}
.el-dropdown-menu__item > .iconfont {
  vertical-align: middle;
}
.touxiang {
  border: 1px solid #dcdcdc;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-image: url(../assets/img/header/def_header.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-right: 10px;
}
.loginName {
  color: #333;
  font-size: 14px;
}
.loginBg {
  height: 420px;
  width: 380px;
  background: #deecff;
  border-radius: 4px 0px 0px 4px;
  position: relative;
  top: -64px;
  left: -20px;
}
.loginBg > img {
  position: absolute;
  top: 105px;
}
.loginWindow .el-dialog__body {
  height: 366px !important;
}
.loginWindow .el-dialog__title {
  padding-left: 355px;
  font-size: 20px !important;
  font-weight: bold;
  color: #303030 !important;
}
.loginWindow .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  border: 1px solid #f4f4f4 !important;
}
.operation {
  display: flex;
  justify-content: space-between;
  margin-top: -15px;
  margin-bottom: 30px;
}
.operation > span {
  cursor: pointer;
}
.operation > span:first-child {
  color: #207ffd;
}
.operation > span:last-child {
  color: #a4a4a4;
}
.loginWindow
  .el-form
  .el-form-item:last-child
  .el-form-item__content
  .el-button {
  width: 100%;
  padding: 16px !important;
  font-size: 16px !important;
}
.loginWindow .el-input__prefix {
  top: 15px;
  left: 20px !important;
}
.loginWindow .el-input--prefix .el-input__inner {
  padding-left: 55px !important;
}
.el-dialog__body {
  padding: 10px 20px 20px !important;
}
.take .el-dialog__body {
  display: flex;
}
.el-form-item {
  margin-bottom: 18px !important;
}
.el-form-item:last-child {
  /* margin-bottom: 200px !important; */
}
.el-button--primary {
  background-color: #4286f5 !important;
  border-color: #4286f5 !important;
}
.user-dropdown {
  .el-dropdown-link {
    height: 70px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -ms-align-items: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .el-dropdown-menu {
    top: 50px !important;
    min-width: 150px;
  }
  .el-dropdown-menu__item {
    padding: 0 50px 0 10px !important;
  }
  .el-dropdown-menu__item > .iconfont {
    vertical-align: middle;
  }
  .touxiang {
    border: 1px solid #dcdcdc;
    border-radius: 50%;
    background-image: url(../assets/img/header/photo.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .loginName {
    color: #333;
    font-size: 14px;
  }
}
</style>


